import { SELECTOR } from './constants';

// NOTE: This is a set of "common" selectors. Our other libraries (@socialive/*) may need to utilize these selectors,
// but the implementation for each of these selectors may vary between applications. Each application will need to
// "configure" their individual implementations via the `setSelector` function.

const delegatedSelector = (type) => {
  const selector = (state) => selector.delegate(state);
  // eslint-disable-next-line no-console
  selector.delegate = () => console.warn(`Selector not implemented: ${type}`);
  return selector;
};

const delegates = Object.fromEntries(Object.values(SELECTOR).map((key) => [key, delegatedSelector(key)]));

export const {
  selectAccountId,
  selectAccountName,
  selectAgoraAppId,
  selectAgoraAuthTokens,
  selectApi,
  selectApp,
  selectAuthToken,
  selectBroadcastDescription,
  selectBroadcastGuestsArray,
  selectBroadcastGuestsMapGuestId,
  selectBroadcastGuestsMapUserId,
  selectBroadcastHash,
  selectBroadcastHostUser,
  selectBroadcastId,
  selectBroadcastName,
  selectBrokerToken,
  selectBrokerUrl,
  selectChannelName,
  selectChannelToken,
  selectChatToken,
  selectEnvironmentConfig,
  selectFeature,
  selectHostUrl,
  selectFeatureTypes,
  selectHasEnteredBroadcast,
  selectHasFeatureLoaded,
  selectIntercomAppId,
  selectIsProduction,
  selectLogRocketId,
  selectLogRocketName,
  selectMixpanelToken,
  selectPlatform,
  selectPreferences,
  selectQueries,
  selectRtmpData,
  selectSimulcastSubstream,
  selectSpeakerSinkId,
  selectSplitApiKey,
  selectSplitInit,
  selectSplitSliceName,
  selectSplitStatus,
  selectStreamConfigsArray,
  selectStreamConfigsMapSfuFeedId,
  selectStreamConfigsMapStreamType,
  selectStreams,
  selectTestId,
  selectToast,
  selectUser,
  selectUserAccountRole,
  selectUserBroadcastRole,
  selectUserEmail,
  selectUserId,
  selectUserLocation,
  selectUserName,
  selectVersion,
} = delegates;

export const setSelector = (key, selector) => {
  const delegate = delegates[key];

  if (!delegate) {
    throw new Error(`Invalid selector: ${key}`);
  }

  delegate.delegate = selector;
};
